export default "__VITE_ASSET__78a52433__$_?component__"